import MapButton from 'components/buttons/MapButton';
import RecenterMapIcon from 'components/icons/RecenterMapIcon';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const RecenterMapButton: FunctionComponent<Props> = ({
    className = '',
    onClick,
    testId = TEST_ID
}) => (
    <MapButton className={className} onClick={onClick} testId={testId}>
        <RecenterMapIcon />
    </MapButton>
);

export default RecenterMapButton;
